// extracted by mini-css-extract-plugin
module.exports = {"input":"_26PDz","eraser":"_1oY5B","eraserSmall":"_2cywh","inputSmall":"q_8Kp","hiddenEraser":"k-Mxk"};